import './parts/vietjet.scss';
import { PageHeader, PageFooter } from './parts/com';

import React from 'react';
import { render } from 'react-dom';
import { withRouter, NavLink } from 'react-router-dom';

import { withTranslation, Trans } from 'react-i18next';

import queryString from 'query-string';

import { Container, Row, Col, Modal, Card } from 'react-bootstrap';

class Intro extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			data: 'Hello',
		};
		this.props.i18n.changeLanguage(this.props.match.params.lang);
	}
	
	changeLanguage = nextLang => {
		const { children, i18n, t, history, match } = this.props;
    const newUrl = `${match.path.replace(':lang',nextLang)}`;
    history.push(newUrl);
    i18n.changeLanguage(nextLang);
	};
	
  handleClickSelectLanguage = (lang) => {
    this.changeLanguage(lang);
	};
	
	render() {

		const {t,i18n} = this.props


		return (
			<div className="app">
				<PageHeader handleClickSelectLanguage={this.handleClickSelectLanguage} lang={this.props.match.params.lang} t={t}/>
				<Container>
					<Row>
						<Col className="mt-5 mb-5">
							<h1>Introduction coming shortly</h1>
						</Col>
						<Col className="mt-5 mb-5">
							<NavLink className="btn" to={`buy`}>Buy Now</NavLink>
						</Col>
					</Row>
				</Container>
				<PageFooter />
			</div>
		);
	}
}

export default withRouter(withTranslation('common')(Intro));
